export const AUTH_KEY = '_auth'
export const ETERNAL_REFRESH_TOKEN = 'eternal_refresh_token'